import React, { useEffect } from 'react';
import ReactDOM from 'react-dom/client';
import ProductViewer from './components/ProductViewer';
import { setRootDivId } from './utils/consoleLogger';

// Function to initialize React in different environments
const initializeApp = () => {
  const rootElement = document.getElementById("root");

  if (rootElement) {
    // Initialize console logger with rootDivId
    setRootDivId("root");
    const root = ReactDOM.createRoot(rootElement);
    root.render(<App rootDiv="root"/>);
  }
};

// Shopify initialization (if running inside Shopify)
window.initializeReactApp = (elementId) => {
  const container = document.getElementById(elementId);
  if (container) {
    // Initialize console logger with rootDivId
    setRootDivId(elementId);
    const root = ReactDOM.createRoot(container);
    root.render(<App rootDiv={elementId}/>);
  }
};

const App = ({rootDiv}) => {

  return (
      <ProductViewer 
        showAdditionalButtons={true}
        showDimensions={false}
        rootDiv={rootDiv}
      />
  );
};

// If running outside Shopify (e.g., localhost, WordPress), ensure React still mounts
if (!document.currentScript || !document.currentScript.dataset.shopify) {
  initializeApp();
}